<div class="modal-header">
    <h3 class="modal-title">MAPS Settings</h3>
    <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
      aria-hidden="true"></button>
  </div>
  <div class="modal-body">
    <div class="my-3 d-flex align-items-center gap-2 justify-content-between" style="width: 100%;">
        <p-slider [(ngModel)]="sliderValue" [min]="0.01" [max]="0.99"  [step]="0.05" [style]="{'width':'500px'}"></p-slider>
        <span class="slider-value">{{ sliderValue }}</span>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-default" [mat-dialog-close]="">Cancel</button>
    <button class="btn btn-sm btn-default" [mat-dialog-close]="" (click)="updatePolicyThreshold()">Save</button>
  </div>
